module.exports = __webpack_public_path__ + "static/img/yun1.d6fa57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yun1.png
// module id = kO9l
// module chunks = 1